import { render, staticRenderFns } from "./inquire.vue?vue&type=template&id=af31580c&scoped=true"
import script from "./inquire.vue?vue&type=script&lang=js"
export * from "./inquire.vue?vue&type=script&lang=js"
import style0 from "./inquire.vue?vue&type=style&index=0&id=af31580c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af31580c",
  null
  
)

export default component.exports